import { RestSetlist, RestSetlistResult, RestSetlistGenerateResult, RestSetlistJob, RestSetlistJobStatus } from '@/types'
import axios from 'axios'
import host from '../../utils/host'

class SetlistRest {
  private host: string = host

  // Logged-in flow: the client created the Spotify playlist itself and passes
  // its id; the backend records it synchronously.
  public create (token: string, campaignId: number, data: RestSetlist): Promise<RestSetlistGenerateResult> {
    return axios.post(`${this.host}/api/users/me/setlists/${campaignId}`, data, {
      headers: {
        Authorization: token
      }
    }).then((res) => res.data)
  }

  // No-login flow: the playlist is created on the shared account server-side in
  // a background job. Returns a job id to poll with `getSetlistJob`.
  public createNoLogin (campaignId: number, data: RestSetlist): Promise<RestSetlistJob> {
    return axios.post(`${this.host}/api/users/spotify/setlists/${campaignId}`, data)
      .then((res) => res.data)
  }

  public getSetlistJob (jobId: string): Promise<RestSetlistJobStatus> {
    return axios.get(`${this.host}/api/users/spotify/setlists/job/${jobId}`)
      .then((res) => res.data)
  }

  public get (campaignId: number): Promise<RestSetlistResult> {
    return axios.get(`${this.host}/api/campaigns/${campaignId}/setlist`)
      .then((res) => res.data)
  }

  public copyToAccount (token: string, campaignId: number, setlistId: number): Promise<RestSetlistGenerateResult> {
    return axios.post(`${this.host}/api/users/me/setlists/${campaignId}/setlists/${setlistId}`, {}, {
      headers: {
        Authorization: token
      }
    }).then((res) => res.data)
  }
}

export default new SetlistRest()
